const prod = {
  url: {
    API_URL: "https://data-core.teampbs.com/enterprise/api",
    CURRENT_USER_API: "currentUser",
  },
  aadClientID: "55a44c35-4853-4447-8052-70d98ee4497a",
  tenantID: "a43be288-8913-475d-97de-5b99b3dcc172",
  //redirectUri: "https://sharepoint.teampbs.com/sites/me/SiteAssets/me/index.aspx",
};

const dev = {
  url: {
    //API_URL: "http://localhost:5384/api",
    API_URL: "https://data-core.teampbs.com/enterprise/api",
    CURRENT_USER_API: "currentUser",
  },
  aadClientID: "55a44c35-4853-4447-8052-70d98ee4497a",
  tenantID: "a43be288-8913-475d-97de-5b99b3dcc172",
  //redirectUri: "http://localhost:3000",
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
